import axios from "axios";
import React, { useState, useEffect } from "react";

const URL = process.env.REACT_APP_BASE_URL;
let API_Token = localStorage.getItem("prime_access_token");

const instance = axios.create({
  baseURL: URL,
  headers: {
    'Content-Type': 'application/json',
    'token': API_Token,
    'X-Requested-With': 'XMLHttpRequest',
  },
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("prime_access_token");
  if (token) {
    config.headers.token = token;
  }
  return config;
});

export default instance;